iScreenWizard.controller('RapporttemplateSelectorController', function ($scope, $state, $mdDialog, Ajax, ErrorHandler, Dictionary, userService, Rapporttemplate, Competentieprofiel, Testotheek, Mailtemplate, Competentiegroep, nieuweTestafnameService) {

    $scope.userService = userService;
    $scope.testafname = nieuweTestafnameService.model;
    $scope.rapporttemplates = [];
    $scope.beschikbareCompetentieprofielen = [];
    $scope.beschikbareCompetentiegroepen = [];

    $scope.COMPETENTIEPROFIELTYPE_THEMA = 1;
    $scope.COMPETENTIEPROFIELTYPE_GENERIEK = 2;
    $scope.COMPETENTIEPROFIELTYPE_GEEN = 3;
    $scope.tests = [];
    $scope.canSkip = false;

    $scope.$on('$stateChangeSuccess', function (event, toState) {
        $scope.refresh();
    });

    $scope.refresh = function() {
        $scope.testafname.alleen_testotheek = 0;

        testotheekparams = {
            testafname_opleidingsniveau_id: $scope.testafname.kandidaat.opleidingsniveau.id
        };
        Testotheek.all(testotheekparams).then(function(tests) {
            $scope.tests = tests;
            if (tests.length > 0 && userService.isExpert()) {
                $scope.canSkip = true;
            }
        });

        params = {
            testafname_opleidingsniveau_id: $scope.testafname.kandidaat.opleidingsniveau.id,
            testafname_taal_id: $scope.testafname.kandidaat.taal.id,
            alleen_met_competentieprofiel_type: 1,
            klantorganisatie_id: $scope.userService.model.klantorganisatie_id
        };
        Rapporttemplate.all(params).then(function (rapporttemplates) {
            angular.forEach(rapporttemplates, function (rapporttemplate) {
                if (rapporttemplate.voorbeeldbestand_url.length > 0) {
                    rapporttemplate.voorbeeldbestand_url = baseUrl + rapporttemplate.voorbeeldbestand_url + '?jwt=' + userService.getToken();
                }
            });
            $scope.rapporttemplates = rapporttemplates;
            if ($scope.testafname.rapporttemplate) {
                loadBeschikbareProfielen($scope.testafname.rapporttemplate);
            }
        });
    };

    $scope.selecteerRapporttemplate = function(rapporttemplate) {
        $scope.testafname.rapporttemplate = rapporttemplate;
        $scope.saveTestafname();
        loadBeschikbareProfielen(rapporttemplate);
    };

    loadBeschikbareProfielen = function(rapporttemplate) {
        $scope.beschikbareCompetentieprofielen = [];
        if (rapporttemplate.competentieprofiel_type == $scope.COMPETENTIEPROFIELTYPE_GENERIEK ||
            rapporttemplate.competentieprofiel_type == $scope.COMPETENTIEPROFIELTYPE_THEMA) {
            //load default profiel
            params = {
                testafname_rapporttemplate_id: rapporttemplate.id,
                testafname_opleidingsniveau_id: $scope.testafname.kandidaat.opleidingsniveau.id
            };
            Competentieprofiel.all(params).then(function (competentieprofielen) {
                //geeft alle beschikbare competentieprofielen terug, voor expert user ook eigen competentieprofielen die voldoen
                $scope.beschikbareCompetentieprofielen = competentieprofielen;
            }, function (response) {
                ErrorHandler.showDialog(reponse);
                $scope.resetRapporttemplate();
            }).then(function() {
                //select (default?) competentieprofiel
                if ($scope.beschikbareCompetentieprofielen.length > 0) {
                    if (!$scope.testafname.competentieprofiel) {
                        $scope.selecteerCompetentieprofiel($scope.beschikbareCompetentieprofielen[0]);
                    } else {
                        $scope.selecteerCompetentieprofiel($scope.testafname.competentieprofiel);
                    }
                }
            });
        }
    };

    $scope.resetRapporttemplate = function() {
        $scope.testafname.rapporttemplate = null;
        $scope.beschikbareCompetentieprofielen = [];
        $scope.saveTestafname();
        $scope.resetCompetentieprofiel();
    };

    $scope.selecteerCompetentieprofiel = function(competentieprofiel) {
        $scope.testafname.competentieprofiel = competentieprofiel;
        $scope.saveTestafname();
        if ($scope.testafname.rapporttemplate.competentieprofiel_type == $scope.COMPETENTIEPROFIELTYPE_THEMA) {
            loadBeschikbareCompetentiegroepen(competentieprofiel);
        }
    };

    $scope.downloadCompetentieprofielVoorbeeld = function(competentieprofiel, ev) {
        $mdDialog.show({
            controller: DownloadCompetentieprofielVoorbeeldDialogController,
            locals: {
                competentieprofiel: competentieprofiel
            },
            templateUrl: '/competentieprofielen/download-voorbeeld',
            parent: angular.element(document.body),
            targetEvent: ev,
            clickOutsideToClose:true
        });
    };

    function DownloadCompetentieprofielVoorbeeldDialogController($scope, $mdDialog, competentieprofiel) {
        $scope.competentieprofiel = competentieprofiel;
        $scope.stillLoading = true;
        $scope.downLoadUrl = '';

        Competentieprofiel.downloadVoorbeeld(competentieprofiel).then(function (response) {
            $scope.stillLoading = false;
            if (ErrorHandler.hasErrors(response)) {
                ErrorHandler.showDialog(response);
            } else {
                $scope.downLoadUrl = baseUrl + response.data.file_url + '?jwt=' + userService.getToken();
            }
        });
    };

    loadBeschikbareCompetentiegroepen = function(competentieprofiel) {
        $scope.beschikbareCompetentiegroepen = [];
        params = {
            competentieprofiel_id: competentieprofiel.id
        };
        Competentiegroep.all(params).then(function (competentiegroepen) {
            const sortedCompetentiegroepen = competentiegroepen.sort(function(a, b) {
                return a.positie - b.positie;
            });
            $scope.beschikbareCompetentiegroepen = sortedCompetentiegroepen;
        }, function (response) {
            ErrorHandler.showDialog(reponse);
            $scope.resetCompetentieprofiel();
        });
    };

    $scope.resetCompetentieprofiel = function() {
        $scope.testafname.competentieprofiel = null;
        $scope.beschikbareCompetentiegroepen = [];
        $scope.testafname.competentiegroepen = [];
        $scope.saveTestafname();
    };

    $scope.selectAllCompetentiegroepen = function() {
        $scope.testafname.competentiegroepen = [];
        angular.forEach($scope.beschikbareCompetentiegroepen, function(groep) {
            $scope.testafname.competentiegroepen.push(groep);
        });
    };

    $scope.saveTestafname = function() {
        nieuweTestafnameService.SaveState();
    };

    $scope.canContinue = function() {
        if ($scope.testafname.rapporttemplate) {
            if ($scope.testafname.rapporttemplate.competentieprofiel_type == $scope.COMPETENTIEPROFIELTYPE_GEEN || $scope.testafname.rapporttemplate.competentieprofiel_type === null) {
                return true;
            }
            if ($scope.testafname.rapporttemplate.competentieprofiel_type == $scope.COMPETENTIEPROFIELTYPE_GENERIEK) {
                if ($scope.testafname.competentieprofiel) {
                    return true;
                }
            }
            if ($scope.testafname.rapporttemplate.competentieprofiel_type == $scope.COMPETENTIEPROFIELTYPE_THEMA) {
                if ($scope.testafname.competentieprofiel && $scope.testafname.competentiegroepen && $scope.testafname.competentiegroepen.length > 0) {
                    return true;
                }
            }
        }
        return false;
    };

    $scope.continue = function() {
        if ($scope.canContinue()) {

            params = {
                testafname_rapporttemplate_id: $scope.testafname.rapporttemplate.id,
                testafname_opleidingsniveau_id: $scope.testafname.kandidaat.opleidingsniveau.id
            };
                      if (userService.isExpert()) {
                //skip testotheek if user doensnt have any tests in testotheek
                if ($scope.tests.length > 0) {
                    $state.go('nieuwe-testafname/selecteer-losse-tests');
                } else {
                    $state.go('nieuwe-testafname/uitnodiging');
                }
            } else {
                $state.go('nieuwe-testafname/uitnodiging');
            }
        }
    };

    $scope.skip = function() {
        if ($scope.canSkip) {
            nieuweTestafnameService.model.alleen_testotheek = 1;
            nieuweTestafnameService.SaveState();
            $state.go('nieuwe-testafname/selecteer-losse-tests');
        }
    }

});